/**
 * charma-watch-block.js
 * Показывает блок совместимости с Charma Italia ТОЛЬКО на товарах с тегом "watch".
 */
(function () {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  var handle = window.location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
  if (!handle) return;

  var CSS = [
    '.ch-watch{border:0.5px solid #b2ccc9;border-radius:12px;overflow:hidden;margin-bottom:16px}',
    '.ch-watch-hero{background:#044a40;padding:14px 16px;display:flex;align-items:center;gap:12px}',
    '.ch-watch-emblem{width:40px;height:40px;border-radius:8px;border:1px solid rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center;flex-shrink:0;background:rgba(255,255,255,.08)}',
    '.ch-watch-emblem svg{width:22px;height:22px;stroke:rgba(255,255,255,.85);fill:none;stroke-width:1.5}',
    '.ch-watch-hero-text{flex:1}',
    '.ch-watch-hero-title{font-size:13px;font-weight:700;color:#fff;letter-spacing:.01em;line-height:1.3;margin-bottom:2px}',
    '.ch-watch-hero-sub{font-size:11.5px;color:#7ec4bc;line-height:1.4}',
    '.ch-italia-pill{flex-shrink:0;border:1px solid rgba(255,255,255,.3);border-radius:6px;padding:4px 9px;text-align:center}',
    '.ch-italia-pill span{display:block;font-size:7.5px;font-weight:800;color:rgba(220,255,250,.9);letter-spacing:.12em;line-height:1.5}',
    '.ch-watch-specs{display:grid;grid-template-columns:1fr 1fr;background:#f3f8f7;padding:12px;gap:8px}',
    '.ch-wspec{background:#fff;border:0.5px solid #dde3e8;border-radius:8px;padding:9px 12px;display:flex;align-items:center;gap:8px}',
    '.ch-wspec-ico{width:28px;height:28px;background:#edf5f4;border-radius:6px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:13px}',
    '.ch-wspec-lbl{font-size:11px;color:#8a9aaa;line-height:1.2;margin-bottom:1px}',
    '.ch-wspec-val{font-size:12px;font-weight:600;color:#1a1a2e;line-height:1.2}',
    '.ch-watch-tip{background:#e6f2f0;padding:10px 14px;border-top:0.5px solid #b2ccc9;display:flex;align-items:center;gap:10px}',
    '.ch-watch-tip-ico{font-size:15px;flex-shrink:0}',
    '.ch-watch-tip-txt{font-size:11.5px;color:#023830;line-height:1.45}'
  ].join('');

  function parseDescSpec(text, label) {
    var re = new RegExp(label + '[:\\s]+([^\\n]+)', 'i');
    var m = text.match(re);
    return m ? m[1].trim().replace(/\s+/g, ' ') : null;
  }

  function inject() {
    if (document.querySelector('.ch-watch')) return;

    var anchor = document.querySelector('ul.icon-with-text');
    if (!anchor) return;

    var descEl = document.querySelector('.product__description');
    var descText = descEl ? descEl.textContent : '';

    var movement = parseDescSpec(descText, 'Mechanizm') || parseDescSpec(descText, 'Strojček') || 'Quartz';
    var dialColor = parseDescSpec(descText, 'Kolor') || parseDescSpec(descText, 'Farba') || parseDescSpec(descText, 'Ciferník') || null;
    var material = parseDescSpec(descText, 'Materiał') || parseDescSpec(descText, 'Materiál') || 'Ušľachtilá oceľ';
    var style = parseDescSpec(descText, 'Styl') || parseDescSpec(descText, 'Štýl') || 'Vintage retro';

    if (material && material.length > 20) material = material.split('(')[0].trim();
    if (style && style.length > 20) style = style.split(',')[0].trim();

    function specItem(ico, lbl, val) {
      return '<div class="ch-wspec"><div class="ch-wspec-ico">' + ico + '</div><div>' +
        '<div class="ch-wspec-lbl">' + lbl + '</div>' +
        '<div class="ch-wspec-val">' + val + '</div>' +
        '</div></div>';
    }

    var specsHTML =
      specItem('⚙️', 'Strojček', movement) +
      (dialColor ? specItem('🔵', 'Ciferník', dialColor) : specItem('✦', 'Povrch', 'Vysoký lesk')) +
      specItem('✦', 'Materiál', material) +
      specItem('🕐', 'Štýl', style);

    var blockHTML =
      '<div class="ch-watch">' +
        '<div class="ch-watch-hero">' +
          '<div class="ch-watch-emblem"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="7"/><path d="M12 8v4l2.5 2.5"/><path d="M9.5 3.5h5M9.5 20.5h5"/></svg></div>' +
          '<div class="ch-watch-hero-text">' +
            '<div class="ch-watch-hero-title">Kompatibilné s Charma Italia šarmikmi</div>' +
            '<div class="ch-watch-hero-sub">Pridaj šarmiky priamo na článkový remienok</div>' +
          '</div>' +
          '<div class="ch-italia-pill"><span>CHARMA</span><span>ITALIA</span></div>' +
        '</div>' +
        '<div class="ch-watch-specs">' + specsHTML + '</div>' +
        '<div class="ch-watch-tip">' +
          '<div class="ch-watch-tip-ico">💡</div>' +
          '<div class="ch-watch-tip-txt">Článkový remienok je kompatibilný so šarmikmi Charma Italia — vytvor si jedinečný štýl.</div>' +
        '</div>' +
      '</div>';

    if (!document.getElementById('ch-watch-style')) {
      var st = document.createElement('style');
      st.id = 'ch-watch-style';
      st.textContent = CSS;
      document.head.appendChild(st);
    }

    if ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0) { var plCopies = {"Kompatibilné s Charma Italia šarmikmi":"Pasuje do charmsów Charma Italia","Pridaj šarmiky priamo na článkový remienok":"Dodaj charmsy bezpośrednio do bransolety ogniwowej","Článkový remienok je kompatibilný so šarmikmi Charma Italia — vytvor si jedinečný štýl.":"Bransoleta ogniwowa pasuje do charmsów Charma Italia — stwórz swój niepowtarzalny styl.","Strojček":"Mechanizm","Quartz":"Kwarcowy","Ciferník":"Tarcza","Povrch":"Wykończenie","Vysoký lesk":"Wysoki połysk","Materiál":"Materiał","Ušľachtilá oceľ":"Stal szlachetna","Štýl":"Styl"}; Object.keys(plCopies).sort(function(a,b){return b.length-a.length;}).forEach(function(s){ blockHTML = blockHTML.split(s).join(plCopies[s]); }); }
    anchor.insertAdjacentHTML('beforebegin', blockHTML);
  }

  // Fetch product JSON — contains tags at product level
  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      var tags = product.tags || [];
      // tags may be a comma-separated string or array depending on Shopify version
      if (typeof tags === 'string') tags = tags.split(',').map(function(t){ return t.trim(); });
      if (tags.indexOf('watch') === -1) return; // not a watch — do nothing

      // It's a watch — inject when DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          inject();
          if (!document.querySelector('.ch-watch')) {
            setTimeout(inject, 300);
            setTimeout(inject, 800);
            setTimeout(inject, 1500);
          }
        });
      } else {
        inject();
        if (!document.querySelector('.ch-watch')) {
          setTimeout(inject, 300);
          setTimeout(inject, 800);
          setTimeout(inject, 1500);
        }
      }
    })
    .catch(function () {});
})();
